import sexuologyQuestionSet from "../faq/sexuology/allQuestions";

export const sexuologyConsultation = {
    'meta': {
        'title': 'Seksuolog, Konsultacje seksuologiczne #cityLocativeIn#',
        'description': 'Seksuolog #cityLocativeIn#, konsultacje seksuologiczne. Doświadczeni psychoterapeuci pomogą Państwu pokonać problemy związane z intymną sferą Państwa życia.'
    },
    'availability': [
        'torun'
    ],
    'price': {
        'torun': {
            'first': 'od 310',
            'next': 'od 280'
        },
        'bydgoszcz': {
            'first': 'od 230',
            'next': 'od 210'
        }
    },
    'url': {
        'address': '#cityIdUrl#/uslugi/seksuolog/',
        'title': 'Porady seksuologa #cityLocativeIn#',
        'name': 'Seksuolog, konsultacje seksuologiczne #cityLocativeIn#',
        'heading': 'Seksuolog, konsultacje seksuologiczne #cityLocativeIn#',
        'fullName': 'Konsultacje seksuologiczne'
    },
    'image': {
        'url': '/images/services/konsultacje-seksuologiczne.webp',
        'width': 840,
        'height': 321,
        'alt': 'Seksuolog, konsultacje seksuologiczne #cityLocativeIn#'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/konsultacje-seksuologiczne.webp',
            'width': 840,
            'height': 321,
            'alt': 'Seksuolog, konsultacje seksuologiczne #cityLocativeIn#'
        }
    },
    'faq': sexuologyQuestionSet
}